document.addEventListener("DOMContentLoaded", function () {
  const productInfoContainer = document.querySelector('.product__info-container');
  const sliderOneTen = document.querySelector('.wknd-slider-one-ten');
  const productInfoWrapper = document.querySelector('.product__info-wrapper');

  // Function to rearrange elements based on screen width
  // function rearrangeElements() {
  //   if (window.innerWidth < 750) {
  //     // Move product__info-container below wknd-slider-one-ten
  //     sliderOneTen.insertAdjacentElement('afterend', productInfoContainer);

  //     // Hide product__info-wrapper
  //     if (productInfoWrapper) {
  //       productInfoWrapper.style.display = 'none';
  //     }
  //   } else {
  //     // Revert back to the original location or display style if needed
  //     productInfoWrapper.style.display = ''; // Reset display property to default
  //   }
  // }
  const originalParent = productInfoContainer.parentElement;

  function rearrangeElements() {
    if (window.innerWidth < 750) {
      sliderOneTen.insertAdjacentElement('afterend', productInfoContainer);
      productInfoWrapper.style.display = 'none';
    } else {
      // Move product__info-container back to its original parent
      originalParent.appendChild(productInfoContainer);
      productInfoWrapper.style.display = '';
    }
  }

  // Initial check and set up an event listener on window resize
  rearrangeElements();
  window.addEventListener('resize', rearrangeElements);
});


